import { Form, Formik } from 'formik'
import ProductPriceFilterField from 'domains/product/organisms/price-filter-field'
import ProductAgeFilterField from 'domains/product/organisms/age-filter-field'
import ProductSellerTypeFilterField from 'domains/product/organisms/seller-type-filter-field'
import ProductProductableTypeFilterField from 'domains/product/organisms/productable-type-filter-field'
import ProductColourFilterField from 'domains/product/organisms/colour-filter-field/product-colour-filter-field'
import ProductConditionFilterField from 'domains/product/organisms/condition-filter-field/product-condition-filter-field'
import ProductBrandClassificationFilterField from 'domains/product/organisms/brand-classification-filter-field/product-brand-classification-filter-field'
import ProductCategoryFilterField from 'domains/product/organisms/category-filter-field/product-category-filter-field'
import ProductNameFilterField from 'domains/product/organisms/name-filter-field/product-name-filter-field'
import ProductSkuFilterField from 'domains/product/organisms/sku-filter-field/product-sku-filter-field'
import ProductGenderFilterField from 'domains/product/organisms/gender-filter-field/product-gender-filter-field'
import ProductSizeFilterField from 'domains/product/organisms/size-filter-field/product-size-filter-field'
import ProductStatusFilterField from 'domains/product/organisms/status-filter-field/product-status-filter-field'
import ProductStockFilterField from 'domains/product/organisms/stock-filter-field/product-stock-filter-field'
import { ListGroup, ListGroupItem } from 'reactstrap'
import { LoaderButton } from 'components/molecules'
import PropTypes from 'prop-types'

const propTypes = {
  initialFilters            : PropTypes.object,
  colours                   : PropTypes.arrayOf(PropTypes.object),
  conditions                : PropTypes.arrayOf(PropTypes.object),
  brandClassifications      : PropTypes.arrayOf(PropTypes.object),
  categories                : PropTypes.arrayOf(PropTypes.object),
  sizes                     : PropTypes.arrayOf(PropTypes.object),
  selectedCategoryOnChanges : PropTypes.func,
  handleSubmitForm          : PropTypes.func.isRequired
}

const defaultProps = {
  initialFilters            : { },
  colours                   : [ {} ],
  conditions                : [ {} ],
  brandClassifications      : [ {} ],
  categories                : [ {} ],
  sizes                     : [ {} ],
  selectedCategoryOnChanges : () => {},
  handleSubmitForm          : () => { }
}

const ProductFilterForm = ({
  initialFilters,
  colours,
  conditions,
  brandClassifications,
  categories,
  sizes,
  selectedCategoryOnChanges,
  handleSubmitForm
}) => {
  const initialValues = {
    name                     : initialFilters?.name || '',
    sku                      : initialFilters?.sku || '',
    gender                   : initialFilters?.gender || '',
    status                   : initialFilters?.status || '',
    age_from                 : initialFilters?.age_from || '',
    age_to                   : initialFilters?.age_to || '',
    price_from               : initialFilters?.price_from || '',
    price_to                 : initialFilters?.price_to || '',
    seller_type              : initialFilters?.seller_type || '',
    productable_type         : initialFilters?.productable_type || '',
    colour_ids               : initialFilters?.colour_ids || [],
    condition_ids            : initialFilters?.condition_ids || [],
    brand_classification_ids : initialFilters?.brand_classification_ids || [],
    category_id              : initialFilters?.category_id || '',
    size_ids                 : initialFilters?.size_ids || [],
    is_in_stock              : initialFilters?.is_in_stock || ''
  }

  return (
    <Formik
      initialValues={ initialValues }
      onSubmit={ handleSubmitForm }
      enableReinitialize={ true }
    >
      {
        (formik) => (
          <Form>
            <ListGroup>

              <ListGroupItem>
                <ProductNameFilterField />
              </ListGroupItem>

              <ListGroupItem>
                <ProductSkuFilterField />
              </ListGroupItem>

              <ListGroupItem>
                <ProductGenderFilterField />
              </ListGroupItem>

              <ListGroupItem>
                <ProductStatusFilterField />
              </ListGroupItem>

              <ListGroupItem>
                <ProductStockFilterField />
              </ListGroupItem>

              <ListGroupItem>
                <ProductAgeFilterField />
              </ListGroupItem>

              <ListGroupItem>
                <ProductCategoryFilterField
                  fieldName='category_id'
                  categories={ categories }
                  formik={ formik }
                  selectedCategoryOnChanges={ selectedCategoryOnChanges }
                />
              </ListGroupItem>

              <ListGroupItem>
                <ProductSizeFilterField
                  fieldName="size_ids"
                  sizes={ sizes }
                  formik = { formik }
                />
              </ListGroupItem>

              <ListGroupItem>
                <ProductConditionFilterField
                  fieldName="condition_ids"
                  conditions={ conditions }
                  formik = { formik }
                />
              </ListGroupItem>

              <ListGroupItem>
                <ProductPriceFilterField />
              </ListGroupItem>

              <ListGroupItem>
                <ProductProductableTypeFilterField />
              </ListGroupItem>

              <ListGroupItem>
                <ProductSellerTypeFilterField />
              </ListGroupItem>

              <ListGroupItem>
                <ProductBrandClassificationFilterField
                  fieldName="brand_classification_ids"
                  brandClassifications={ brandClassifications }
                  formik = { formik }
                />
              </ListGroupItem>

              <ListGroupItem>
                <ProductColourFilterField
                  fieldName="colour_ids"
                  colours={ colours }
                  formik = { formik }
                />
              </ListGroupItem>

              <div className='d-flex justify-content-center position-sticky fixed-bottom bg-white py-3'>
                <LoaderButton
                  className='float-right'
                  color='primary'
                  type='submit'
                  disabled={ formik.isSubmitting }
                  isLoading={ formik.isSubmitting }
                  text={ 'SEARCH' }
                />
              </div>

            </ListGroup>
          </Form>
        )
      }

    </Formik>
  )
}

ProductFilterForm.propTypes    = propTypes
ProductFilterForm.defaultProps = defaultProps

export default ProductFilterForm
